
export const loadLineUpsConstantsAction = ( constants ) => {
    return { type: "LINEUPS:LOAD_CONSTANTS", constants }
}

export const loadAlignmentsAction = ( alignments ) => {
    return { type: "LINEUPS:LOAD_ALIGNMENTS", alignments }
}